import React, { useRef, useEffect } from 'react';
import { extend, useFrame } from '@react-three/fiber';
import * as THREE from 'three';

// Extend will make THREE.Points available as a native JSX element called 'points'
extend({ Points: THREE.Points });

const ParticlesComponent = () => {
  const particlesRef = useRef();

  useEffect(() => {
    const particles = particlesRef.current;

    // Create a geometry
    const particlesGeometry = new THREE.BufferGeometry();
    // const count = 1000;
    const count = 5000;

    // Create buffers for positions and colors
    const positions = new Float32Array(count * 3);
    const colors = new Float32Array(count * 3);

    for (let i = 0; i < count; i++) {
      // Position
    //   positions[i * 3] = (Math.random() - 0.5) * 10;
    //   positions[i * 3 + 1] = (Math.random() - 0.5) * 10;
    //   positions[i * 3 + 2] = (Math.random() - 0.5) * 10;

    positions[i * 3] = (Math.random() - 0.5) * 50;
    positions[i * 3 + 1] = (Math.random() - 0.5) * 50;
    positions[i * 3 + 2] = (Math.random() - 0.5) * 50;

      // Color
      colors[i * 3] = Math.random();
      colors[i * 3 + 1] = Math.random();
      colors[i * 3 + 2] = Math.random();
    }

    particlesGeometry.setAttribute('position', new THREE.BufferAttribute(positions, 3));
    particlesGeometry.setAttribute('color', new THREE.BufferAttribute(colors, 3));

    // Create a material
    const particlesMaterial = new THREE.PointsMaterial({
      size: 0.1,
      vertexColors: true,
    });

    // Create points
    const points = new THREE.Points(particlesGeometry, particlesMaterial);
    particles.add(points);

    return () => {
      particlesGeometry.dispose();
      particlesMaterial.dispose();
    };
  }, []);

  useFrame(() => {
    if (particlesRef.current) {
      particlesRef.current.rotation.y += 0.001;
    }
  });

  return <group ref={particlesRef} />;
};

export default ParticlesComponent;




